var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.color,staticStyle:{"bottom":"70px","z-index":"2"},attrs:{"fab":"","fixed":"","bottom":"","right":_vm.left ? false : true,"left":_vm.left ? true : false},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }